<div class="text-base text-gray-900">
	<p class="mb-5 text-base">
		Disconnecting will remove your firm’s ability to prepare and send packages
		for e-signature using SignIT.
	</p>

	<p class="mb-5 text-base">
		This action may impact ongoing e-signing workflows.
	</p>
	<p class="font-medium pl-4 mb-2">{{ capabilities.title }}</p>

	<ul class="mb-5 pl-12 list-disc">
		@for (item of capabilities.items; track $index) {
			<li class="py-1">{{ item.text }}</li>
		}
	</ul>

	<p class="font-medium pl-4 mb-2">
		{{ existingPackages.title }}
	</p>

	<ul class="pl-12 list-disc">
		@for (item of existingPackages.items; track $index) {
			<li class="py-1">{{ item.text }}</li>
		}
	</ul>
</div>
